<template>
  <el-tooltip content="返回上一级" placement="top" :open-delay="160">
    <button class="level-back-button" type="button" aria-label="返回上一级" @click="back"><span class="level-back-button__arrow" aria-hidden="true">←</span></button>
  </el-tooltip>
</template>
<script>
export default {
  name: 'LevelBackButton',
  props: { to: { type: String, default: '/' } },
  methods: {
    back() {
      if (this.$listeners.back) this.$emit('back')
      else this.$router.push(this.to)
    }
  }
}
</script>
<style scoped>
.level-back-button {
  width: 32px; height: 28px; padding: 0; display: inline-flex; align-items: center; justify-content: center;
  color: var(--awb-ink, var(--text-primary)); background: transparent;
  border: 1px solid var(--awb-line, var(--border-default)); border-radius: var(--radius-sm);
  font-family: inherit; font-size: var(--fs-md); cursor: pointer; transition: 0.2s;
}
.level-back-button:hover, .level-back-button:focus-visible {
  color: var(--commerce-primary, var(--icon-action));
  border-color: var(--commerce-primary, var(--icon-action));
  background: var(--commerce-primary-soft, var(--awb-surface-2));
  box-shadow: none;
}
.level-back-button__arrow { display: inline-block; transform: translateY(-2px); }
</style>
